var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"candela-component md-container flex-grow-1 flex-shrink-0"},[_c('v-card-text',{staticClass:"md ma-0 pa-3"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.md)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }